import { SVGProps } from 'react'

export const MockQr = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M13.271 0H0v13.285h13.27zm-3.126 10.155H3.126V3.11h7.019z"
			fill="#0A0909"
		/>
		<path
			d="M8.198 5.078H5.072v3.13h3.126zM39.959 0H26.687v13.285H39.96zm-3.085 10.155h-7.04V3.11h7.04z"
			fill="#0A0909"
		/>
		<path
			d="M34.886 5.078H31.76v3.13h3.126zM13.271 26.715H0V40h13.27zm-3.126 10.156H3.126v-7.026h7.019z"
			fill="#0A0909"
		/>
		<path
			d="M8.198 31.793H5.072v3.13h3.126zM6.253 15.378H3.127v3.13h3.126zm3.043 6.259v3.11h3.106v-3.11H9.358v-3.13H6.253v3.13zM25.01 6.01h-3.125v3.13h3.126zm-6.273-2.901H15.61v6.01h3.127zM21.884 0h-3.126v3.13h3.126zm0 9.14h-3.127v3.109H15.61v3.13h6.274zm-3.127 15.606v3.068h3.127v3.046h6.232v-3.13h-6.232v-3.046h-3.127v-6.176H15.61v6.238z"
			fill="#0A0909"
		/>
		<path
			d="M25.01 15.378h-3.125v6.26h3.126zm6.232 9.306h8.737v-6.26h-3.105v-3.046H31.18v3.13h-3.043v3.13h3.126v3.046zm0-6.176h5.632v3.046h-5.611zM40 27.73h-3.126v6.26H40z"
			fill="#0A0909"
		/>
		<path
			d="M28.116 21.637H24.99v3.13h3.126zm3.127 9.223h-3.126v3.13h3.126zm3.125-3.13h-3.126v3.13h3.126z"
			fill="#0A0909"
		/>
		<path
			d="M34.348 40v-2.923h2.526v-3.109h-5.632V40zM18.737 27.813H15.61v5.948h3.127zM21.884 40v-3.13h3.043V40h3.106v-3.13H24.99v-3.13h-6.232V40zM15.61 15.378H9.358v3.13h6.252z"
			fill="#0A0909"
		/>
	</svg>
)
